import ApiResource from '@/api/ApiResource.js'
export default {
  data () {
    return {
      searchString: '', org_selected: false, show_dropdown: false, on_blur_close: false, is_loading: false, drop_down_opened: false, businesses: [], business_available: false
    }
  },
  computed: {
    orgsFound () {
      return this.businesses.length > 0
    },
    showOrgLookDropdown () {
      if (this.on_blur_close && !this.org_selected) {
        return ''
      }
      if ((this.org_selected || this.businesses.length > 0) && !this.on_blur_close) {
        return 'is-active'
      }
    }
  },
  methods: {
    forwardSearch (searchKey) {
      if (searchKey.length > 0) {
        this.$router.push({
          path: '/search-results',
          query: {
            search: searchKey.trim()
          }
        })
      }
    },
    orgLookup () {
      this.org_selected = false
      this.show_dropdown = false
      this.on_blur_close = false
      if (this.searchString.length < 3) {
        this.businesses = []
        this.show_dropdown = false
      } else {
        this.is_loading = true
        let keyword = encodeURIComponent(this.searchString.trim())
        new ApiResource({}).send(`/search/business?name=${keyword}`, {}, 'get')
          .then((businesses) => {
            if (businesses.length === 0) {
              this.businesses = []
              this.org_selected = true
              this.show_dropdown = false
              this.drop_down_opened = false
              this.is_loading = false
            } else {
              this.drop_down_opened = true
              this.businesses = businesses
              this.is_loading = false
            }
          })
          .catch(() => {
            this.is_loading = false
            this.drop_down_opened = false
          })
      }
    },
    hideBusinessAutoComplete () {
      try {
        this.searchString = this.searchString.trim()
        this.drop_down_opened = true
        this.on_blur_close = true
        const parent = this
        parent.business_available = false
        this.businesses.forEach((business) => {
          let inlist = false
          if (this.searchString.toLowerCase() === business.name.toLowerCase() && !inlist) {
            if (business.status === 'ACTIVE') {
              parent.business_available = false
              parent.org_selected = true
              parent.drop_down_opened = false
            } else if (!inlist) {
              inlist = true
              parent.org_selected = true
              parent.business_available = true
              parent.drop_down_opened = false
            }
          }
          if (this.searchString.toLowerCase() !== business.name.toLowerCase() && !inlist) {
            parent.business_available = true
            parent.drop_down_opened = false
            parent.org_selected = true
          }
        })
      } catch (e) {
      }
    },
    selectOrg (business) {
      this.org_selected = true
      this.businesses = []
      this.drop_down_opened = false
      this.$router.push(`/${business.slug}`)
      window.location.reload()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/search.js